import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { InviteRequest } from '@shared/invite/models';
import { ApiClientService } from '@tablesready/api-client';

@Injectable({ providedIn: 'root' })
export class InviteApiService {
  private readonly path = '/v.1/invite';

  constructor(
    private readonly http: ApiClientService,
  ) {}

  accept(id: string): Observable<void> {
    return this.http.post<void>(`${this.path}/${id}/accept`, {})
  }

  decline(id: string): Observable<void> {
    return this.http.post<void>(`${this.path}/${id}/decline`, {})
  }

  remove(id: string): Observable<void> {
    return this.http.delete<void>(`${this.path}/${id}`);
  }

  resend(id: string): Observable<void> {
    return this.http.put<void>(`${this.path}/${id}/resend`, {})
  }

  send(data: InviteRequest): Observable<void> {
    return this.http.post<void>(this.path, data);
  }
}
